/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zone_EnduranceInputs */

const en_ui_zone_endurance = /** @type {(inputs: Ui_Zone_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endurance`)
};

const de_ui_zone_endurance = /** @type {(inputs: Ui_Zone_EnduranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausdauer`)
};

/**
* | output |
* | --- |
* | "Endurance" |
*
* @param {Ui_Zone_EnduranceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zone_endurance = /** @type {((inputs?: Ui_Zone_EnduranceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zone_EnduranceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zone_endurance(inputs)
	return de_ui_zone_endurance(inputs)
});